import { NOTIFICATION } from '../constants';

export const initialNotificationState = null;

export default (state = initialNotificationState, action) => {
  switch (action?.type) {
    case NOTIFICATION.ADD_NOTIFICATION:
      return action?.notification ? action?.notification : null;
    case NOTIFICATION.REMOVE_NOTIFICATION:
      return null;
    default:
      return state;
  }
};
